<template>
	<div class="drawer">
		<el-drawer size="600px" title="编辑员工" :visible.sync="drawerStatus" @close='close' :close-on-press-escape="false" :wrapperClosable="false" :modal-append-to-body="false" >
			<el-form style="padding:10px 36px 0 0px;">
				<el-row>
					<el-col :span="24">
						<el-form-item label="姓名：" :label-width="formLabelWidth" prop="nick_name">
							<el-input v-model="form.realName" placeholder="请输入" autocomplete="off" ></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="账号：" :label-width="formLabelWidth" prop="nick_name">
							<el-input v-model="form.userName" placeholder="请输入" disabled autocomplete="off" ></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="性别：" :label-width="formLabelWidth" prop="nick_name">
							<el-radio-group v-model="form.sex">
								<el-radio :label="'男'">男</el-radio>
								<el-radio :label="'女'">女</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="手机号：" :label-width="formLabelWidth" prop="nick_name">
							<el-input :value="detail.basic_info&&detail.basic_info.user_mobile" placeholder="请输入" disabled autocomplete="off" ></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="邮箱：" :label-width="formLabelWidth" prop="nick_name">
							<el-input v-model="form.userEmail" placeholder="请输入" autocomplete="off" ></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="住址：" :label-width="formLabelWidth" prop="nick_name">
							<el-input v-model="form.userAddress" placeholder="请输入" autocomplete="off" ></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="状态：" :label-width="formLabelWidth" prop="nick_name">
							<el-radio-group v-model="form.status">
								<el-radio :label="1">在职</el-radio>
								<el-radio :label="0">离职</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="部门：" :label-width="formLabelWidth" prop="nick_name">
							<el-input :value="detail.archives_info&&detail.archives_info.department" placeholder="请输入" disabled autocomplete="off" ></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="职位：" :label-width="formLabelWidth" prop="nick_name">
							<el-select v-model="form.position" placeholder="请选择" style="width:100%;">
								<el-option v-for="item in zhiweiList" :key="item.name" :label="item.name" :value="item.name">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="权限：" :label-width="formLabelWidth" prop="nick_name">
							<el-select v-model="form.roleInfo" placeholder="请选择" multiple style="width:100%;">
								<el-option v-for="item in roleList" :key="item.id" :label="item.roleName" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="所属门店：" :label-width="formLabelWidth" prop="nick_name">
							<el-select v-model="form.ownerShopId" placeholder="请选择" style="width:100%;">
								<el-option v-for="item in shopList" :key="item.shop_id" :label="item.shop_name" :value="item.shop_id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="参与门店：" :label-width="formLabelWidth" prop="nick_name">
							<el-select v-model="form.joinShopIds" placeholder="请选择" multiple style="width:100%;">
								<el-option v-for="item in shopList" :key="item.shop_id" :label="item.shop_name" :value="item.shop_id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="系统门店：" :label-width="formLabelWidth" prop="nick_name">
							<el-select v-model="form.systemShopIds" placeholder="请选择" multiple style="width:100%;">
								<el-option v-for="item in shopList" :key="item.shop_id" :label="item.shop_name" :value="item.shop_id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="擅长：" :label-width="formLabelWidth" prop="nick_name">
							<el-input v-model="form.speciality" placeholder="请输入" autocomplete="off" ></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="简历：" :label-width="formLabelWidth" prop="nick_name">
							<el-input v-model="form.resume" placeholder="请输入" autocomplete="off" ></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="描述：" :label-width="formLabelWidth" prop="nick_name">
							<el-input v-model="form.introduce" placeholder="请输入" autocomplete="off" ></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div style="height: 40px;width:100%;"></div>
			<div class="btnBox">
				<div class="btnItem" @click="close">取消</div>
				<div class="btnItem submit" @click="submit">确定</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				formLabelWidth: '110px',
				
				// 职位
				curZhiweiIndex: 0,
				zhiweiList: [],
				roleList:[],
				
				shopList: this.$store.state.allShopList,
				detail: {},
				
				form: {
					"id": "",
					"userName": "",
					"userMobile": "",
					"realName": "",
					"avatarPic": "",
					"userEmail": "",
					"userAddress": "",
					"sex": "",
					"departmentId": "",
					"departmentName": "",
					"departmentIds": [],
					"joinShopIds": [],
					"ownerShopId": "",
					"roleInfo": "",
					"introduce": "",
					"position": "",
					"systemShopIds": [],
					"status": 0,
					"resume": "",
					"speciality": "",
				},
			}
		},
		props:{
			row:{
				default:()=>{
					return {}
				}
			}
		},
		mounted() {
			this.$nextTick(()=>{
				this.drawerStatus=true;
			})
			this.getStaffDetail(this.row._id)
		},
		methods: {
			close(){
				this.$emit("submit",{type:'close'})
			},
			// 保存基本信息
			submit() {
				let params = this.form
				params.roleInfo = params.roleInfo.join(',')
				let loading = this.$loading()
				this.$http.post(process.env.VUE_APP_baseData+'/api/staffinfo/update', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.$message({
							message: '保存成功',
							type: 'success'
						});
						this.$emit("submit",{type:'success',data:''})
					}
				})
				
			},
			getStaffDetail(id) {
				let loading = this.$loading()
				this.$http.get(process.env.VUE_APP_baseData + '/api/staffinfo/' + id, {}).then(res => {
					loading.close()
					this.detail = res.data;
					let d = res.data;
					let joinShopIds = []
					for (let i = 0; i < d.shop_info.length; i++) {
						joinShopIds.push(d.shop_info[i].shop_id)
					}
					let role = []
					if(!this.$public.isNull(d.role_info)){
						role = d.role_info.split(',')
					}
					this.form = {
						"id": d._id,
						"userName": d.basic_info.user_name,
						"userMobile": d.basic_info.user_mobile,
						"realName": d.basic_info.real_name,
						"avatarPic": d.basic_info.avatar_pic,
						"userEmail": d.basic_info.user_email,
						"userAddress": d.basic_info.user_address,
						"sex": d.archives_info.sex,
						"departmentId": d.archives_info.department_id,
						"departmentName": d.archives_info.department,
						"departmentIds": d.archives_info.departmentIds,
						"joinShopIds": joinShopIds,
						"ownerShopId": d.shopId,
						"roleInfo": role,
						"introduce": d.archives_info.introduce,
						"position": d.archives_info.position,
						"systemShopIds": d.system_shop_ids,
						"status": d.status,
						"speciality": d.archives_info.speciality,
						"resume": d.archives_info.resume
					}
					this.getZhiweiList();
					this.getRoleList()
				})
			},
			getZhiweiList() {
				this.$http.post(process.env.VUE_APP_baseData + '/api/dict/stafftype/list', {
					pageIndex: 1,
					pageSize: 500,
					keyword: ''
				}).then(res => {
					this.zhiweiList = res.data.data
				})
			},
			getRoleList() {
				this.$http.post(process.env.VUE_APP_baseData+'/api/Role/list', {}).then(res => {
					if (res.code == 0) {
						this.roleList = res.data;
					}
				})
			}
		}
	}
</script>

<style scoped lang="scss">
	.drawer{
		.btnBox{
			width:100%;font-size: 14px;color:#fff;line-height: 40px;display: flex;position: absolute;bottom: 0;z-index: 10;
			.btnItem{
				text-align: center;width:100%;background-color: #D6D6D6;cursor: pointer;
				&.submit{
					background-color: #3569FF;
				}
			}
		}
		
		
		
		
		
		
		
		
		
		.imgBox{
			display: flex;flex-wrap: wrap;
			.imgItem{
				position: relative;width:128px;height: 128px;margin:0 16px 16px 0;
				.closeBtn {
					display: block; color: red; position: absolute; top: -15px; right: -15px; font-size: 30px; z-index: 5;
				}
			}
			.avatar-uploader-icon {
				font-size: 28px; color: #8c939d; width: 128px; height: 128px; line-height: 128px; text-align: center; background: #F0F0F7; border: 1px dashed #B0B0BF; border-radius: 8px; box-sizing: border-box;
			}
		}
	}
	
</style>
